/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  message,
  Select,
  DatePicker,
  Spin,
} from "antd";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { APIs, getToken } from "../../../utils/worker";
import { PaperClipOutlined, CloseCircleOutlined } from "@ant-design/icons";
import "./style.scss";
import moment from "moment";
import { useRef } from "react";
import axios from "axios";
import { capitalize, showErrorMessage } from "../../../utils";

const token = getToken();
const toolbarConfig = {
  fontColor: {
    colors: [
      {
        color: "hsl(0, 0%, 0%)",
        label: "Black",
      },
      {
        color: "hsl(0, 0%, 30%)",
        label: "Dim grey",
      },
      {
        color: "hsl(0, 0%, 60%)",
        label: "Grey",
      },
      {
        color: "hsl(0, 0%, 90%)",
        label: "Light grey",
      },
    ],
  },
  fontBackgroundColor: {
    colors: [
      {
        color: "hsl(0, 75%, 60%)",
        label: "Red",
      },
      {
        color: "hsl(30, 75%, 60%)",
        label: "Orange",
      },
      {
        color: "hsl(60, 75%, 60%)",
        label: "Yellow",
      },
      {
        color: "hsl(90, 75%, 60%)",
        label: "Light green",
      },
      {
        color: "hsl(120, 75%, 60%)",
        label: "Green",
      },

      // ...
    ],
  },
  toolbar: {
    items: [
      "heading",
      "|",
      "bold",
      "|",
      "fontColor",
      "|",
      "italic",
      "|",
      "link",
      "|",
      "underline",
      "|",
      "strikethrough",
      "|",
      "superscript",
      "subscript",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "insertTable",
      "|",
      "fontBackgroundColor",
      "|",
      "undo",
      "redo",
    ],
  },
  // image: {
  //   toolbar: [
  //     'imageStyle:full',
  //     'imageStyle:side',
  //     '|',
  //     'imageTextAlternative'
  //   ]
  // },
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  },
  language: "en",
};

const CreateBroadcast = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const selectedHubs = Form.useWatch("hub", form);
  const fileInputRef = useRef(null);
  const [currentDate, setCurrentDate] = useState();
  const [file, setFile] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [messageData, setMessageData] = useState("");
  const [broadcastTo, setBroadcastTo] = useState("");
  const [hubCpZoneList, setHubCpZoneList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editorRefreshKey, setEditorRefreshKey] = useState(0);

  const removeAttachmentDisplayOnly = (html) => {
    if (!html) return "";
    // Remove the Attachment bold text and its following content/link
    let cleaned = html.replace(/<p>\s*<b>Attachment:<\/b>[\s\S]*?<\/p>/gi, "");
    // Remove any preview images (blob or data urls)
    cleaned = cleaned.replace(/<img [^>]*src=["'](blob:|data:)[^"']*["'][^>]*>/gi, "");
    // Clean up trailing breaks or empty paragraphs that might be left behind
    return cleaned.trim();
  };

  const broadcastToOptions = [
    { label: "All", value: "ALL" },
    // { label: "All Zone", value: "ALL ZONE" },
    //{ label: "All Hub", value: "ALL HUB" },
    // { label: "All CP", value: "ALL CP" },
    // { label: "Zone", value: "ZONE" },
    { label: "Hub", value: "HUB" },
    //{ label: "CP", value: "CP" },
  ];
  const priorityOptions = [
    { label: "High", value: "HIGH" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Low", value: "LOW" },
  ];

  useEffect(() => {
    let date = new Date();
    let today = formatedDate(date);
    form.setFieldValue("createdOn", today);
    setCurrentDate(today);
    setTimeout(() => {
      window.scroll(0, 0);
    }, 100);
  }, []);


  const formatedDate = (date) => {
    let dd = date.getDate();

    let mm = date.getMonth() + 1;
    let yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }

    if (mm < 10) {
      mm = "0" + mm;
    }
    let today = dd + "/" + mm + "/" + yyyy;
    return today;
  };

  const dateFormat = "DD/MM/YYYY";

  const disabledDate = (current) => {
    return current < moment().startOf("day");
  };

  const disabledDateNext = (current) => {
    return current <= moment(fromDate, "DD/MM/YYYY").startOf("day");
  };

  const changeFromDate = (date, dateString) => {
    setFromDate(dateString);
    form.setFieldValue("validTo", null);
  };

  const changeBroadcast = (data) => {
    setBroadcastTo(data);
    form.setFieldValue("hub", []);
    getHubCpZone(data);
  };

  const changeHubData = (data) => {
    // console.log(data);
    form.setFieldValue("hub", data);
  };

  const getHubCpZone = async (data) => {
    try {
      let response = await axios.get(
        APIs.baseURL + "/broadcast-service/v1/broadcast/premises/" + data,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        let temp = [];
        response.data.map((e) => {
          temp.push({
            label: capitalize(e.name),
            value: e.name,
          });
        });
        setHubCpZoneList(temp);
        setIsLoading(false);
      }
    } catch (error) {
      showErrorMessage(error.response.data.message);
      setIsLoading(false);
    }
  };

  const removeAttachment = () => {
    const cleanedMessage = removeAttachmentDisplayOnly(messageData);
    setMessageData(cleanedMessage);
    form.setFieldsValue({ message: cleanedMessage });
    setEditorRefreshKey((prev) => prev + 1);

    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const createBroadcast = async (values) => {
    setIsLoading(true);
    let temp = [];
    if (values.hub !== undefined) {
      values.hub.map((e) => {
        temp.push({
          name: e,
        });
      });
    }

    const payload = {
      createdOn: currentDate,
      validFrom: fromDate,
      validTo: toDate,
      title: values.title,
      message: messageData.replace(/<img [^>]*src=["'](data:image\/[^"']+|blob:[^"']+)["'][^>]*>/gi, ""),
      broadcastTo: values.broadcastTo,
      priorityType: values.priority,
      broadcastToDtos: temp,
    };

    try {
      const formData = new FormData();
      formData.append(
        "data",
        new Blob([JSON.stringify(payload)], { type: "application/json" })
      );
      if (file) {
        formData.append("file", file);
      }

      const response = await axios.post(
        APIs.baseURL + "/broadcast-service/v1/broadcast",
        formData,
        {
          headers: {
            Authorization: token,
            token: token.split("Bearer ")[1],
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        message.success(
          response?.data?.message || "Broadcast Created Successfully"
        );
        form.resetFields();
        setFile(null);
        setMessageData("");
        setEditorRefreshKey((prev) => prev + 1);
        setIsLoading(false);
      }
    } catch (error) {
      showErrorMessage(error.response?.data?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  return (
    <Spin spinning={isLoading}>
      <div className="master-main-container">
        <div className="p-1">
          <p className="f-16 fw-500 title-color">Broadcast Message</p>
          <hr className="divider" />
        </div>
        <Form
          className="global-form"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createBroadcast}
        >
          <Row className="global-form-row">
            <Col xs={1} sm={1} md={4} lg={4} xl={4}></Col>
            <Col xs={22} sm={22} md={16} lg={16} xl={16}>
              {/* <div className="profile d-flex center ml-2">
                {profileDetailsResult?.data?.firstName.substring(1, 0).toUpperCase()}
              </div> */}
              <Row gutter={20} className="global-form-row">
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="createdOn"
                    label="Created on"
                    initialValue={currentDate}
                  >
                    <Input placeholder="Created on" disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}></Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="validFrom"
                    label="Valid from"
                    // initialValue={moment(fromDate, dateFormat)}
                    rules={[
                      {
                        required: true,
                        message: "Please select valid from",
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disabledDate}
                      format={dateFormat}
                      onChange={(date, dateString) =>
                        changeFromDate(date, dateString)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="validTo"
                    label="Valid to"
                    // initialValue={moment(toDate, dateFormat)}
                    rules={[
                      {
                        required: true,
                        message: "Please select valid to",
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disabledDateNext}
                      format={dateFormat}
                      onChange={(date, dateString) => setToDate(dateString)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="broadcastTo"
                    label="Broadcast to"
                    // initialValue={moment(toDate, dateFormat)}
                    rules={[
                      {
                        required: true,
                        message: "Please select",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Broadcast To"
                      options={broadcastToOptions}
                      onChange={(data) => changeBroadcast(data)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  {broadcastTo === "HUB" ||
                    broadcastTo === "CP" ||
                    broadcastTo === "ZONE" ? (
                    <Form.Item
                      name={"hub"}
                      label={broadcastTo + " names"}
                      // initialValue={moment(toDate, dateFormat)}
                      rules={[
                        {
                          required: true,
                          message: "Please select",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        options={hubCpZoneList}
                        placeholder={"Select " + broadcastTo + " names"}
                        allowClear
                        maxTagCount={1}
                        maxTagPlaceholder={(omittedValues) => `... +${omittedValues.length}`}
                        showSearch
                        optionFilterProp="label"
                        className="small-dropdown"
                      />
                    </Form.Item>
                  ) : (
                    ""
                  )}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingTop: selectedHubs?.length > 1 ? "18px" : "0px" }}>
                  <Form.Item
                    name="title"
                    label="Title"
                    rules={[
                      {
                        required: true,
                        message: "Please input title",
                      },
                    ]}
                  >
                    <Input placeholder="Title" maxLength={70} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingTop: selectedHubs?.length > 1 ? "18px" : "0px" }}>
                  <Form.Item
                    name="priority"
                    label="Priority"
                    // initialValue={moment(toDate, dateFormat)}
                    rules={[
                      {
                        required: true,
                        message: "Please select priority",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select priority type"
                      options={priorityOptions}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}></Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    name="message"
                    label="Message"
                    rules={[
                      { required: true, message: "Please enter a message" },
                      {
                        validator: (_, value) => {
                          if (value && value.length > 600) { // Using 600 as a soft buffer since HTML tags take up space, but reporting 600 to user.
                            return Promise.reject("Message cannot be more than 600 characters");
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <CKEditor
                      key={editorRefreshKey}
                      config={toolbarConfig}
                      editor={ClassicEditor}
                      data={messageData}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setMessageData(data);
                        // Manually sync with Ant Design Form to prevent 'required' errors on paste
                        form.setFieldsValue({ message: data });
                        form.validateFields(["message"]);
                      }}
                      maxLength={10}
                    />
                    {messageData.length + "/600"}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={1} sm={1} md={4} lg={4} xl={4}></Col>
          </Row>
          <hr className="divider" />
          <div className="d-flex flex-end p-1">
            {file && (
              <span className="file-name-display" style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
                {file.name}
                <CloseCircleOutlined
                  style={{ color: "#ff4d4f", marginLeft: "5px", cursor: "pointer", fontSize: "16px" }}
                  onClick={removeAttachment}
                />
              </span>
            )}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => {
                const selectedFile = e.target.files[0];
                if (selectedFile) {
                  setFile(selectedFile);
                  let cleanedMessage = removeAttachmentDisplayOnly(messageData);

                  let attachmentHtml = "";
                  if (selectedFile.type.startsWith("image/")) {
                    const imageUrl = URL.createObjectURL(selectedFile);
                    attachmentHtml = `<p><b>Attachment:</b><br/><img src="${imageUrl}" style="max-width:200px; height:auto; margin-top:10px;" alt="preview"/></p>`;
                  } else {
                    attachmentHtml = `<p><b>Attachment:</b> ${selectedFile.name}</p>`;
                  }

                  const newMessage = cleanedMessage + attachmentHtml;
                  setMessageData(newMessage);
                  form.setFieldsValue({ message: newMessage });
                  setEditorRefreshKey((prev) => prev + 1);
                }
              }}
            />
            <Button
              className="btn-style cancel-btn ml-1"
              icon={<PaperClipOutlined />}
              onClick={() => fileInputRef.current.click()}
            >
              ATTACHMENT
            </Button>
            <Form.Item shouldUpdate className="m-0">
              {() => (
                <Button
                  htmlType="submit"
                  className="btn-style save-btn ml-1 w-10"
                  disabled={
                    !!form.getFieldsError().filter(({ errors }) => errors.length).length ||
                    !form.getFieldValue("title") ||
                    !form.getFieldValue("message") ||
                    !form.getFieldValue("validFrom") ||
                    !form.getFieldValue("validTo") ||
                    !form.getFieldValue("priority")
                  }
                >
                  SAVE
                </Button>
              )}
            </Form.Item>
          </div>
        </Form>
      </div>
    </Spin>
  );
};
export default CreateBroadcast;
